/**
 *  Require external libraries
 */
window.jQuery = window.$ = require("./external/jquery.js");
require("./external/unveil.js");
require("./external/tablesort.js");
//require("./external/swipeSlider.js");

/**
 *  Require helper functions
 */


/**
 *  Require includes
 */

var Tracking = require("./includes/tracking.js");
var AffiliateEpi = require("./includes/affiliateEpi.js");
var SocialShare = require("./includes/socialShare.js");
var ToTop = require('./includes/toTop.js');
var ContactForm = require("./includes/contactForm.js");
var LazyLoad = require("./includes/lazyLoad.js");
var CookieConsent = require("./includes/cookieConsent.js");
var Rating = require("./includes/rating.js");
var AccessibleMenu = require("./includes/accessibleMenu.js");
var AlgoliaAutocomplete = require("./includes/algoliaAutocomplete.js");
var HomePageSlider = require("./includes/homePageSlider.js");
var ProteinCalculator = require("./includes/proteinCalculator.js");
var Comments = require("./includes/comment.js");

var CompareTable = require("./includes/compareTable.js");

function init(){
    setTimeout(function() {
        var App = {};
        window.App = App;

        App.Tracking = new Tracking();
        App.AffiliateEpi = new AffiliateEpi();
        App.SocialShare = new SocialShare();
        App.ToTop = new ToTop();
        App.ContactForm = new ContactForm();
        App.CookieConsent = new CookieConsent();
        App.Rating = new Rating();
        App.AccessibleMenu = new AccessibleMenu();
        App.AlgoliaAutocomplete = new AlgoliaAutocomplete();
        App.HomePageSlider = new HomePageSlider();
        App.ProteinCalculator = new ProteinCalculator();

        App.Comments = new Comments();

        App.LazyLoad = new LazyLoad();
        App.LazyLoad.init()

        App.CompareTable = new CompareTable();

        $(".sub-menu .show-hide").on("click", function(){
            $(this).parent().toggleClass("active");

            if(this.innerText == "[visa]")
            {
                this.innerText = "[göm]";
            }
            else
            {
                this.innerText = "[visa]";
            }
        });

        $("#list-review .show-hide").on("click", function(){
            $(this).parent().parent().toggleClass("hide");

            if(this.innerText == "[visa]")
            {
                this.innerText = "[göm]";
            }
            else
            {
                this.innerText = "[visa]";
            }
        });


        $(".main-menu > ul > li > .main-menu-item").on("click", function(){
            $(this).siblings().removeClass("active");
            $(this).next().toggleClass("active");
        });

        $(document).ready(function() {
            $('.round').each(function(i,round){
                $round = $(round),
                roundRadius = $round.find('circle').attr('r'),
                roundPercent = $round.data('percent'),
                roundCircum = 2 * roundRadius * Math.PI,
                roundDraw = roundPercent * roundCircum / 100
                $round.css('stroke-dasharray', roundDraw  + ' 999');
            });
        });

        function loadVideo() {
            setTimeout(function(){
                $(".yt-video").find("iframe").each(function(_, iframe){
                    iframe.src = $(iframe).data("src");
                });
            }, 10);
        }

        if($(".yt-video").length)
        {
            $(window).on("scroll.Youtube", function(){
                if($(window).scrollTop() > $(".yt-video").offset().top - window.innerHeight - 100) {
                    $(window).off("scroll.Youtube");
                    loadVideo();
                }
            });
        }

        $("td.title").on("click", function(){
            window.scrollTo(0, $(".review[data-productid=" + $(this).data("target") + "]").offset().top - 120);
        });

        $(".admin-overlay").on("click.regen", function()
        {
            var $overlay = $(this);
            var id = $(this).data("id");

            $(this).css("background", "gray");
            $(this).css("pointer-events", "none");
            $(this).find(".regenerate").html("Loading...");
            
            $.get("/regenerate/" + id).done(function (data, textStatus, jqXHR) {
              console.log(data, textStatus, jqXHR);
              $overlay.find(".regenerate").text("OK");
            }).fail(function (jqXHR, textStatus, errorThrown) {
              console.log("Error:", textStatus, errorThrown, jqXHR.responseText);
              $overlay.find(".regenerate").text("Error - Se console (f12)");
            });
        });

        $(".search-icon").on("click", function(){
            $(this).parent().toggleClass("active");
            $(this).next().click();
        });

        $(".test-winner-container li").on("click", function(){
            var product = $("#product-" + $(this).data("productid"));

            window.scrollTo(0,product.offset().top);
        });

        $(".compare-table .link").on("click", function(){
            var product = $("#product-" + $(this).parents("tr").data("productid"));

            window.scrollTo(0,product.offset().top);
        });

        $(".comment-reply-link").on("click", function(){
            $(this).parents(".comment").find(".comment-replies-container").toggle()
        });

        $(".cookie-consent-actions").on("click", function() {
            $(".cookie-consent").hide();
            App.CookieConsent.setCookie("cookie-consent", "consent", 3650);
        });


        //var slider = $('.ff-slider').swipeSlider();
    }, 10);
}

$(document).ready(init);
